import React, { Fragment, useCallback, useEffect, useState } from "react"
import './AdresseContact_box.css'
import { emailsMagasins, Magasin } from "../../../../../Models/Magasin/MagasinModels"
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {List, ListItem, ListItemText, IconButton, Collapse, Card, CardHeader, CardContent, Skeleton, Dialog, Alert, Button, ListItemButton, Divider, ListItemAvatar, Avatar} from '@mui/material';
import {ExpandLess, ExpandMore} from '@mui/icons-material';
import { Email, TypeEmail } from "../../../../../Models/Email/EmailModels"
import { EmailService } from "../../../../../Services/Email/EmailService"
import { useCookies } from "react-cookie"
import {DialogAddEditAdresse} from "../dialog_add_edit_adresse/DialogAddEditAdresse";
import { URL_MIDIS } from "../../../../../Setting";

export interface BoxAdresseContactProps{
    typeAdresse:TypeEmail,
    magasins : Magasin[]
    sendLoading:any,
    loading:boolean,
    setOpenSnackbar:any,
    setSnackbarState:any
}

interface InitialStateI {
  [key: string]: boolean;
}

export function BoxAdresseContact(props : BoxAdresseContactProps){

  const {magasins, sendLoading, loading, typeAdresse, setOpenSnackbar, setSnackbarState}=props;

  
  //gestion alert supression
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedIDEmailDeleted, setSelectedIDEmailDeleted] = useState<number>(0);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMagasins, setSelectedIndex] = useState<Magasin>();
  const [titleCard, setTitleCard] = useState<string>('');
  
  const [emailsMagasin, setEmailsMagasin] = useState<emailsMagasins[]>([]);
  const magasinState:InitialStateI = Object.fromEntries(emailsMagasin.map((value)=>([value.magasin, false])));
  const [openMagasin, setOpenMagasin] = useState(magasinState);

  const [editedEmail, setEditedEmail] = useState<Email>();
  const [editedEmailMagasin, setEditedEmailMagasin] = useState<emailsMagasins>();
  const [cookies] = useCookies(['token']);
  const [state,setState]=useState('');

  //gestion selction magasin
  const handleMagasinClick = (
    index: Magasin,
  ) => {
    setSelectedIndex(index);
    setOpenMagasin((o)=>({ ...magasinState, [index.id]: !o[index.id] }));
  };

  const handleOpenAddDialog = ()=>{
    setState('Add')
    setOpenDialog(true)
  }

  const handleOpenEditDialog = ()=>{
    setState('Edit')
    setOpenDialog(true)
  }

  const handleCloseAddDialog = ()=>{
    setOpenDialog(false)
  }

  async function handleDelete() {
    setSnackbarState('Delete')
    sendLoading(true);
    let status=await EmailService().deleteAdresseContact(selectedIDEmailDeleted, cookies.token);
    switch(status){
      case 200:
        setOpenAlert(false);
        setOpenSnackbar(true);
        break;
      default:
        break;
    }
  }

  const handleAddEdit = ()=>{
    sendLoading(true);
    if(state==='Add'){
      setSnackbarState('Add');
    }else if(state==='Edit'){
      setSnackbarState('Edit');
    }
    setOpenSnackbar(true);
  }

  const FetchEmailsbyTypeForMagasins = useCallback((type:TypeEmail)=>{
    let resultEmailsMagasins:emailsMagasins[]=[];

    for(const magasin of magasins){
      let partialEmailsMagasin:emailsMagasins = {
          idMagasin:magasin.id, magasin:magasin, 
          typeEmail:type, emails:[]
      };
      if(magasin.emails){
          magasin.emails.forEach((email: Email) => {
              if(email.typeEmail){
                  if(email.typeEmail.id === type.id){
                      partialEmailsMagasin.emails.push(email);
                  }
              }
          });
      }
      resultEmailsMagasins.push(partialEmailsMagasin);
    }
    setEmailsMagasin(resultEmailsMagasins);
  },[magasins]);

  useEffect(()=>{
    if(magasins){
      setTitleCard(typeAdresse.type);
      FetchEmailsbyTypeForMagasins(typeAdresse);
    }
  },[FetchEmailsbyTypeForMagasins, emailsMagasin.length, magasins, sendLoading, typeAdresse])

//&& typeof typeAdresse!=='undefined'
  return(
    <div className='VosAdressesContacts-body-box'>
      {
        (typeAdresse) ? 
        <>
          <Card sx={{borderRadius:4}}>
            <CardHeader
              title={titleCard}
              action={
                <IconButton aria-label="add" onClick={handleOpenAddDialog}>
                  <AddIcon fontSize="small"/>
                </IconButton>
              }
              disableTypography
              sx={{fontSize:16, fontWeight:600}}
            />
            <CardContent>
              {
                (!loading && emailsMagasin.length>0)?
                <List
                  sx={{ width: '100%', bgcolor: 'background.paper', height:'100%' }}
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                >
                  {
                    //Virtualized list si bcp trop de données à gérer
                    emailsMagasin.map((magasinEmails, index)=>(
                      <Fragment key={index}>
                        <ListItemButton
                          selected={selectedMagasins === magasinEmails.magasin}
                          onClick={() => handleMagasinClick(magasinEmails.magasin)}
                        >
                          <ListItemAvatar sx={{maxWidth:'12%', marginRight:'6px'}}>
                            <Avatar sx={{width:'100%', height:'unset'}} variant='square' alt='logo' src={magasinEmails.magasin.typeMagasin && magasinEmails.magasin.typeMagasin.fichiers.length>0 ? `${URL_MIDIS+magasinEmails.magasin.typeMagasin.fichiers[0].chemin}` : ''}/>
                          </ListItemAvatar>
                          <ListItemText slotProps={{ primary: {fontSize:16} }} primary={magasinEmails.magasin.nom.toUpperCase()} />
                          {openMagasin[magasinEmails.magasin.id] ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openMagasin[magasinEmails.magasin.id]} timeout="auto" unmountOnExit>
                          <List key={magasinEmails.magasin.id} component="div" disablePadding>
                            {
                              magasinEmails.emails.length>0 ? (
                                magasinEmails.emails.map((mail, index)=>(
                                  <Fragment key={index}>
                                    <ListItem
                                      key={Object.keys(mail)[index]}
                                      secondaryAction={
                                        <>
                                          <IconButton size="small" edge="end" aria-label="edit" onClick={() =>{ handleOpenEditDialog(); setEditedEmail(mail); setEditedEmailMagasin(magasinEmails)} }>
                                            <EditIcon fontSize="inherit"/>
                                          </IconButton>
                                          <IconButton size="small" edge="end" aria-label="delete" onClick={() =>{ setOpenAlert(true); setSelectedIDEmailDeleted(mail.id);} }>
                                            <DeleteIcon fontSize="inherit"/>
                                          </IconButton>
                                        </>
                                      } 
                                    >
                                      <ListItemText slotProps={{ primary: {fontSize:16} }} primary={mail.email} />
                                    </ListItem>
                                    <Divider component="li" variant="middle"/>
                                  </Fragment>
                                ))
                              ) : (
                                <ListItem>
                                  <ListItemText slotProps={{ primary: {fontSize:16, fontWeight:'bold'} }} primary="Aucune adresse de contact" />
                                </ListItem>
                              )
                            }
                          </List>
                        </Collapse>
                      </Fragment>
                    ))
                  }
                </List>:
                <>
                  <Skeleton animation="wave"></Skeleton>
                  <Skeleton animation="wave"></Skeleton>
                  <Skeleton animation="wave"></Skeleton>
                </>
              }
            </CardContent>
          </Card>
          <DialogAddEditAdresse
            open={openDialog}
            editedEmailMagasin={editedEmailMagasin}
            editedEmailDialog={editedEmail}
            state={state}
            onClose={handleCloseAddDialog}
            emailsMagasins={emailsMagasin}
            typeEmail={typeAdresse}
            handleAddEdit={handleAddEdit}
            setSnackbarState={setSnackbarState}
          />
        </>
        : <Skeleton animation="wave" height={100} width="40%"></Skeleton>
      }
      <Dialog open={openAlert}>
        <Alert
            severity='warning'
            action={
                <div>
                    <Button
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            setOpenAlert(false);
                        }}
                    >
                        Non
                    </Button>
                    <Button
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={handleDelete}
                    >
                        Oui
                    </Button>
                </div>
            }
        >
            Voulez-vous supprimer cette adresse de contact ?
        </Alert>
      </Dialog>
    </div>
  )
}